import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateMiniEventItem} from '#core/application/modules/tiles/mini-event-item/index.js';

export function getInPlayMenuFactory(PALETTE) {
    const {FONT} = PALETTE;
    const CONTAINER_STYLE = {
        fontFamily: FONT.FAMILY,
        ...(PALETTE.DESKTOP_INPLAY_MENU_SHOW_SHADOW ? {boxShadow: PALETTE.DESKTOP_INPLAY_MENU_SHADOW} : {}),
        ...resolveBackground(PALETTE.DESKTOP_INPLAY_MENU_CONTAINER_BG),
        borderRadius: PALETTE.DESKTOP_INPLAY_MENU_BORDER_RADIUS,
        ...(PALETTE.DESKTOP_INPLAY_MENU_BORDER_WIDTH && PALETTE.DESKTOP_INPLAY_MENU_BORDER_COLOR !== 'none'
            ? {
                  borderWidth: PALETTE.DESKTOP_INPLAY_MENU_BORDER_WIDTH,
                  borderColor: PALETTE.DESKTOP_INPLAY_MENU_BORDER_COLOR,
                  borderStyle: 'solid',
              }
            : undefined),
        overflow: 'hidden', // needed for round corners
    };

    return {
        // Vertical menu with events (mini event cards)
        InPlaySideMenu: {
            container: {
                style: CONTAINER_STYLE,
            },
            expandable: {
                container: {
                    style: PALETTE.DESKTOP_INPLAY_MENU_SPORTS_SHOW_SEPARATOR
                        ? {
                              borderWidth: '0 0 1px 0',
                              borderColor: PALETTE.DESKTOP_INPLAY_MENU_SPORTS_SEPARATOR_COLOR,
                              borderStyle: 'solid',
                          }
                        : {},
                },
                headerTextContainer: {
                    style: PALETTE.DESKTOP_INPLAY_MENU_SPORT_ITEM_TEXT,
                },
                headerContainer: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.DESKTOP_INPLAY_MENU_SPORT_ITEM_BG),
                        },
                    },
                },
                leftIcon: {
                    style: {
                        minWidth: '16px',
                        minHeight: '16px',
                        fill: PALETTE.DESKTOP_INPLAY_MENU_SPORT_ITEM_ICON_COLOR,
                    },
                },
                rotation: {
                    image: {
                        style: {
                            fill: PALETTE.DESKTOP_INPLAY_MENU_SPORT_ITEM_EXPAND_ICON_COLOR,
                            minHeight: 8,
                            minWidth: 8,
                        },
                    },
                },
            },
            miniEventItem: merge(generateMiniEventItem(PALETTE.DESKTOP_INPLAY_MENU_EVENT_ITEM), {
                container: {
                    style: {
                        base: PALETTE.DESKTOP_INPLAY_MENU_EVENT_ITEM_SHOW_SEPARATOR
                            ? {
                                  borderWidth: '0 0 1px 0',
                                  borderColor: PALETTE.DESKTOP_INPLAY_MENU_EVENT_ITEM_SEPARATOR_COLOR,
                                  borderStyle: 'solid',
                              }
                            : {},
                        active: {
                            borderWidth: 0,
                        },
                    },
                },
            }),
            eventGroupLabelContainer: {
                style: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    ...PALETTE.DESKTOP_INPLAY_MENU_EVENT_GROUP_LABEL_TEXT,
                    ...resolveBackground(PALETTE.DESKTOP_INPLAY_MENU_EVENT_GROUP_LABEL_BG),
                },
            },
            showAllButtonLabel: {
                style: {
                    fontSize: FONT.SIZE_MEDIUM,
                    ...PALETTE.DESKTOP_INPLAY_MENU_SHOW_ALL_BUTTON.TERTIARY_BUTTON_TEXT,
                },
            },
            showAllButtonIcon: {
                style: {
                    fill: PALETTE.DESKTOP_INPLAY_MENU_SHOW_ALL_BUTTON.TERTIARY_BUTTON_ICON_COLOR,
                },
            },
        },
    };
}
